import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { type Profile, useAuthStore } from '@/stores/auth-store'
import { apiFetch } from '@/lib/api-client'
import { Button } from '@/components/ui/button'
import {
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { AuthLayout } from '@/features/auth/auth-layout'

export const Route = createFileRoute('/(auth)/verify-email')({
  validateSearch: (search) => ({
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: VerifyEmailRoute,
})

function VerifyEmailRoute() {
  const { error } = Route.useSearch()
  const navigate = useNavigate()
  const setProfile = useAuthStore((state) => state.setProfile)
  const setAuth = useAuthStore((state) => state.setAuth)

  useEffect(() => {
    if (error) return

    const syncProfile = async () => {
      try {
        const me = await apiFetch<{ success: boolean; data: Profile }>(
          '/api/auth/me'
        )
        if (me.success) {
          setProfile(me.data)
          setAuth({ source: 'cookie' })
        }
      } catch {
        // Ignore if user is not authenticated yet.
      }
    }

    void syncProfile()
  }, [error, setAuth, setProfile])

  useEffect(() => {
    if (!error) return
    toast.error('El enlace de verificacion no es valido o ya expiro')
  }, [error])

  return (
    <AuthLayout>
      <CardHeader>
        <CardTitle className='text-lg tracking-tight'>
          {error ? 'Verificacion fallida' : 'Correo verificado'}
        </CardTitle>
        <CardDescription>
          {error
            ? 'No pudimos verificar tu correo. Solicita un nuevo enlace desde tu cuenta.'
            : 'Tu correo fue verificado correctamente. Ya puedes activar passkeys.'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          type='button'
          className='w-full'
          onClick={() => navigate({ to: '/sign-in' })}
        >
          Ir a iniciar sesion
        </Button>
      </CardContent>
      <CardFooter>
        <p className='text-muted-foreground text-center text-sm'>
          Si sigues teniendo problemas, contacta al administrador.
        </p>
      </CardFooter>
    </AuthLayout>
  )
}
